export const blockIconsCommunicationForwardToInbox = (
	<span className='material-symbols-outlined'>forward_to_inbox</span>
);
